import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

interface VulnerabilitySummary {
  severity: string;
  count: number;
  color: string;
}

const data: VulnerabilitySummary[] = [
  { severity: 'Critical', count: 2, color: '#d32f2f' },
  { severity: 'High', count: 5, color: '#f44336' },
  { severity: 'Medium', count: 8, color: '#ff9800' },
  { severity: 'Low', count: 12, color: '#ffeb3b' },
  { severity: 'Info', count: 15, color: '#2196f3' },
];

const VulnerabilityChart: React.FC = () => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="severity" />
        <YAxis />
        <Tooltip />
        {data.map((entry, index) => (
          <Bar key={`bar-${index}`} dataKey="count" fill={entry.color} name={entry.severity} />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default VulnerabilityChart;